import {
  SET_HOTELS,
} from '../types';

const initialState = {
  hotelsList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_HOTELS:
      return {
        ...state,
        hotelsList: action.data,
      };
    default:
      return state;
  }
};
